module.exports = __webpack_public_path__ + "img/selecta_logo.26533993.png";